let capturedElements = [];
let userTips = [];

class UserTip {
    constructor(element) {
        this.element = element;
        this.id = element.id;
        this.closers = this.getClosers();
        this.storeName = 'userTipsStore';     
        this.store = this.getUserTipsStore();
        this.dismissed = this.isDismissed();   

        this.init();
    }

    init() {
      if (this.dismissed) {
        this.element.dataset.state = 'dismissed';
        return;
      }
      
      this.element.dataset.state = 'active';
      // this.incrementUserTipViews();
      this.addEvents();
    }

    isDismissed() {
      if (jweather.isWebView) {
        if (!jweather.userTips) return true;

        const ids = jweather.userTips.split(',');
        
        // if id is found in jweather.userTips than it should be shown and is not dismissed. So we return the opposite with "!"
        return !ids.includes(this.id.toString());
      }

      return this.getUserTipStateValue('dismissed');
    }

    getUserTipsStore() {
      if (jweather.isWebView) {
          return null;
      }

      const store = localStorage.getItem(this.storeName);

      if (!store) {
        localStorage.setItem(this.storeName, '{}');

        return {};
      }

      return JSON.parse(store);
    }

    setUserTipsStore() {
      localStorage.setItem(this.storeName, JSON.stringify(this.store));
    }

    getUserTipStateValue(key) {    
      let userTipState = this.store[this.id];

      if (!userTipState) {
          this.store[this.id] = {
            dismissed: false,
            // views: 0,
          }

          userTipState = this.store[this.id];
          this.setUserTipsStore();
      }

      return userTipState[key];
    }

    setUserTipStateValue(key, value) {
      this.store[this.id][key] = value;
    }

    incrementUserTipViews() {
      const views = this.getUserTipStateValue('views') + 1;
      this.setUserTipStateValue('views', views);
      this.setUserTipsStore();

      return views;
    }

    getClosers() {
        return [...this.element.querySelectorAll('[data-user-tip-closer]')];
    }

    addEvents() {
        this.closers.forEach(closer => closer.addEventListener('click', this.clickHandler, { once: true }));
    }

    clickHandler = e => {
        if (e.target.tagName.toLowerCase !== 'a') {
          e.preventDefault();
        }

        if (jweather.isWebView) {
          this.webViewClickHandler(e);
          return;
        }

        this.store[this.id].dismissed = true;
        this.element.dataset.state = 'dismissed';
        this.setUserTipsStore();
    };

    webViewClickHandler = e => {
      const action = e.currentTarget.dataset.action;

      try {
        if (jweather.platform == 'android') {
            alert(`userTipAction,${action},${this.id}`);
        } else {
            var info = {
                type: 'userTipAction',
                action: action,
                id: this.id,
            };
  
            window.webkit.messageHandlers.observe.postMessage(info);
        }
      } catch (e) {
        console.warn('messageHandlers not available.');
      }

      this.element.dataset.state = 'dismissed';
    }
}

export const addUserTip = (element) => {
  capturedElements.push(element);
  userTips.push(new UserTip(element));
}

export default init = (target = document) => {
    if (typeof jweather === 'undefined') {
        return;
    }

    const targetElements = [...target.querySelectorAll('[data-user-tip]')];
    const dedupedTargetElements = targetElements.filter(targetElement => !capturedElements.find(capturedElement => targetElement === capturedElement));

    if (dedupedTargetElements.length === 0) return;

    dedupedTargetElements.forEach(element => {
        addUserTip(element);
    });
}